import type { ConfigurePresetResult } from '@cli-types/next-adapter/runtime.js'
import type { BetterstartPresetDefinition } from '@cli-types/preset-engine/presets.js'
import { appendEnvVars } from '@cli-utils/files.js'

export function configurePreset(
  definition: BetterstartPresetDefinition,
  cwd: string
): ConfigurePresetResult {
  const envResult = appendEnvVars(cwd, definition.envSections)
  return {
    configured: true,
    addedEnvKeys: envResult.added,
    updatedEnvKeys: envResult.updated
  }
}
